module.exports = "pegasus/assets/frame-large-linkedin.png";